import { MyleTableColumn, MyleTableColumnOptions } from "@/Common/Components/Tables/MyleTableColumn";
import { TableDataSourceItem } from "@/Common/Models/UI/Tables/ITableDataSourceItem";
import { ValueSetType } from "../Constants/ValueSetType";
import { ImmunizationRecommendationModel } from "../Models/ImmunizationRecommendationModel";
import { QuebecVaccinationRegistryHelper } from "../QuebecVaccinationRegistryHelper";
import { BaseImmunizationTable, BaseImmunizationTableProps } from "./BaseImmunizationTable";

class ExpectedImmunizationTable extends BaseImmunizationTable<BaseImmunizationTableProps<ImmunizationRecommendationModel>, ImmunizationRecommendationModel> {
    protected title(): string {
        return cacheStore.GetString("QuebecVaccinationRegistry_PlannedVaccinationsLabel");
    }

    protected tableId(): string {
        return "vaccination-profile-expected";
    }

    private labels = {
        AgentOrAntigen: "QuebecVaccinationRegistry_AntigenImmunizingAgentLabel",
        ExpectedNumberOfDoses: "QuebecVaccinationRegistry_ExpectedDoseNumberLabel",
        ExpectedDate: "PlannedLabel",
        EligibleDate: "QuebecVaccinationRegistry_EligibleLabel",
        Status: "StatusDLabel",
        TradeName: "QuebecVaccinationRegistry_CommercialNameLabel"
    };

    private fieldNames = {
        AgentOrAntigen: "AgentOrAntigen",
        ExpectedNumberOfDoses: "ExpectedNumberOfDoses",
        ExpectedDate: "ExpectedDate",
        EligibleDate: "EligibleDate",
        Status: "Status",
        TradeName: "TradeName"
    };

    protected defaultTableOptions(): Immutable.List<MyleTableColumnOptions> {
        return Immutable.List([
            new MyleTableColumnOptions({
                HeaderText: cacheStore.GetString(this.labels.AgentOrAntigen),
                FieldName: this.fieldNames.AgentOrAntigen,
                WidthPercentageDefault: 30
            }),
            new MyleTableColumnOptions({
                HeaderText: cacheStore.GetString(this.labels.TradeName),
                FieldName: this.fieldNames.TradeName,
                WidthPercentageDefault: 20
            }),
            new MyleTableColumnOptions({
                HeaderText: cacheStore.GetString(this.labels.ExpectedNumberOfDoses),
                FieldName: this.fieldNames.ExpectedNumberOfDoses,
                WidthPercentageDefault: 12
            }),
            new MyleTableColumnOptions({
                HeaderText: cacheStore.GetString(this.labels.ExpectedDate),
                FieldName: this.fieldNames.ExpectedDate,
                WidthPercentageDefault: 13
            }),
            new MyleTableColumnOptions({
                HeaderText: cacheStore.GetString(this.labels.EligibleDate),
                FieldName: this.fieldNames.EligibleDate,
                WidthPercentageDefault: 13
            }),
            new MyleTableColumnOptions({
                HeaderText: cacheStore.GetString(this.labels.Status),
                FieldName: this.fieldNames.Status,
                WidthPercentageDefault: 12
            })
        ]);
    }

    protected getTableColumns(tableOptions: Immutable.List<MyleTableColumnOptions>): Immutable.List<MyleTableColumn> {
        return MyleTableColumn.buildList<TableDataSourceItem<ImmunizationRecommendationModel>>(
            tableOptions,
            column => {
                switch (column.FieldName) {
                    case this.fieldNames.AgentOrAntigen:
                        return {
                            renderCell: item => <div>{QuebecVaccinationRegistryHelper.translateValueSetString(item.Model.Vaccine, item.Model.IsForAgent ? ValueSetType.Agent : ValueSetType.Antigen)}</div>
                        };

                    case this.fieldNames.TradeName:
                        return {
                            renderCell: item => <div>{item.Model.TradeName}</div>
                        };

                    case this.fieldNames.ExpectedNumberOfDoses:
                        return {
                            renderCell: item => <div>{item.Model.DoseNumber}</div>
                        };

                    case this.fieldNames.ExpectedDate:
                        return {
                            renderCell: item => <div>{this.formatDate(item.Model.DateCriteria[1].Date)}</div> // Date criteria indexes: [EarliestDate, Due, PastDueDate]
                        };

                    case this.fieldNames.EligibleDate:
                        return {
                            renderCell: item => <div>{this.formatDate(item.Model.DateCriteria[0].Date)}</div>
                        };

                    case this.fieldNames.Status:
                        return {
                            renderCell: item => (
                                <div>
                                    {QuebecVaccinationRegistryHelper
                                        .translateValueSetString(item.Model.ForecastStatus, ValueSetType.ForecastStatus)
                                    }
                                </div>
                            )
                        };
                }
            },
            false
        );
    }
}

export { ExpectedImmunizationTable };
